import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import type { Country } from '../../../features/geography/types';

import styles from './CountryCodeDisplay.module.scss';
import internationalIcon from './internationalIcon.svg';

const dataTestIds = {
  option: (index?: number) => `settings-select-country-${index}`,
  placeholder: (_index?: number) => 'settings-select-country-field',
  singleValue: (_index?: number) => 'settings-select-country-field',
};

export function CountryCodeDisplay(props: {
  country?: Country;
  type: 'option' | 'placeholder' | 'singleValue';
  index?: number;
}) {
  const { t } = useTranslation();
  const imageSrc = props.country?.code
    ? `https://catamphetamine.github.io/country-flag-icons/3x2/${props.country?.code}.svg`
    : internationalIcon;

  const getDataTestId = () => {
    if (dataTestIds[props.type]) {
      return dataTestIds[props.type](props.index);
    }
  };

  return (
    <div className={styles.displayWrapper} data-testid={getDataTestId()}>
      <img alt={props.country?.code} className={styles.flagIcon} src={imageSrc} />
      <span className={classNames([styles.callingCode, { [styles.placeholder]: !props.country?.name }])}>
        {props.country?.name ?? t('forms.selectCountry')}
      </span>
    </div>
  );
}
